var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticStyle:{"margin-top":"39px"}},[_c('h4',{staticClass:"balsa-pading-left-5"},[_vm._v("Language")]),_c('Select',{staticStyle:{"margin-top":"10px"},attrs:{"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }